import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MEAPeriodTypes, NewSimulationService} from '../new-simulation.service';
import {Form, FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {MEAPeriodEntity} from '../../../entities/mea-period-entity';

@Component({
    selector: 'app-simulation-input',
    templateUrl: './simulation-input.component.html',
    styleUrls: ['./simulation-input.component.css']
})
export class SimulationInputComponent implements OnInit {

    public section: any;
    public isProgress = false;
    private numberOfPeriods: number;
    private agreementType: MEAPeriodTypes;

    public simulationInputForm = this.formBuilder.group({
        scenarioDescription: [''],
        periods: this.formBuilder.array([])
    });

    constructor(private formBuilder: FormBuilder, private service: NewSimulationService, private router: Router) {
        this.section = service.sections[2];
    }

    ngOnInit() {

        if (!this.service.sections[1].completed) {
            this.router.navigate(['/new-simulation/mea-selection']);
        }

        if (this.service.sections[1].data[0]) {
            this.numberOfPeriods = parseInt(this.service.sections[1].data[0].numberOfMEAPeriods);
            this.agreementType = this.service.sections[1].data[0].agreementType;
        }

        if (this.section.data.length > 0) {
            for (let period of this.section.data) {
                const formArray: FormArray = <FormArray>this.simulationInputForm.controls['periods'];
                formArray.push(this.generateMEAPeriod(period, this.agreementType.toString()));
            }
        } else {
            for (let i = 0; i < this.numberOfPeriods; i++) {
                const formArray: FormArray = <FormArray>this.simulationInputForm.controls['periods'];
                const data = new MEAPeriodEntity();
                this.section.data.push(data);
                formArray.push(this.generateMEAPeriod(data, this.agreementType.toString()));
            }
        }
    }

    onNextClicked() {

        const formArray: FormArray = <FormArray>this.simulationInputForm.controls['periods'];

        if (this.agreementType.toString() === 'PVA-V') {

            for (let i = 0; i < formArray.controls.length; i++) {

                this.section.data[i]['PVA_V'] = [];

                const valueArray = formArray.controls[i]['controls']['PVA-V'].controls;
                for (let y = 0; y < valueArray.length; y++) {

                    const valueController = valueArray[y];

                    this.section.data[i]['PVA_V'].push({
                        valueLimit: valueController.controls["volumeLimit"].value,
                        discount : valueController.controls["discount"].value
                    });
                }
            }
        }

        if (this.agreementType.toString() === 'PVA-S') {
            for (let i = 0; i < formArray.controls.length; i++) {

                this.section.data[i]['PVA_S'] = [];

                const valueArray = formArray.controls[i]['controls']['PVA-S'].controls;
                for (let y = 0; y < valueArray.length; y++) {

                    const valueController = valueArray[y];

                    this.section.data[i]['PVA_S'].push({
                        priceLimit: valueController.controls["priceLimit"].value,
                        discount : valueController.controls["discount"].value
                    });
                }
            }
        }

        this.section.completed = true;
        let that = this;
        this.isProgress = true;
        this.service.fetchResults(this.agreementType.toString())
            .subscribe(function (result) {
                that.isProgress = false;
                that.service.sections[3].data = result;
                that.router.navigate(['/new-simulation/simulation-result']);
            }, (error) => {
                this.isProgress = false;
            });
    }

    private generateMEAPeriod(data: MEAPeriodEntity = null, discountType: string): FormGroup {
        let group: FormGroup;

        if (!data) {
            group = this.formBuilder.group({
                POPNUMCYC: [''],
                PKGPPCYC: [''],
                EXFLISTP: [''],
                CLAWBACK: [''],
                PRCDISC: [''],
                PRCCUT: [''],
                PRCCONFIDDISCCYC: [''],
                REIMBGROSSCYC: [''],
            });
        } else {
            group = this.formBuilder.group({
                POPNUMCYC: [data.POPNUMCYC],
                PKGPPCYC: [data.PKGPPCYC],
                EXFLISTP: [data.EXFLISTP],
                CLAWBACK: [data.CLAWBACK],
                PRCDISC: [data.PRCDISC],
                PRCCUT: [data.PRCCUT],
                PRCCONFIDDISCCYC: [data.PRCCONFIDDISCCYC],
                REIMBGROSSCYC: [data.REIMBGROSSCYC]
            });

        }

        switch (discountType) {
            case 'EC' : {
                group.addControl('EXCAP', this.formBuilder.control(''));
                break;
            }

            case 'UC' : {
                group.addControl('PSUALU', this.formBuilder.control(''));
                group.removeControl('PKGPPCYC');
                break;
            }

            case 'FCPP' : {
                group.addControl('FCPPC', this.formBuilder.control(''));
                break
            }

            case 'PVA-V' : {
                group.addControl('PVA-V', this.formBuilder.array([]));
                this.generateVolumeTreshold(group);
                break;
            }

            case 'PVA-S' : {
                group.addControl('PVA-S', this.formBuilder.array([]));
                this.generatePriceTrashold(group);
                break;
            }

        }

        return group;
    }

    public generateVolumeTreshold(group: FormGroup) {
        const volumeArray: FormArray = <FormArray>group.controls['PVA-V'];
        volumeArray.push(this.formBuilder.group({
            volumeLimit: [''],
            discount: ['']
        }));
    }

    public generatePriceTrashold(group: FormGroup) {
        const priceArray: FormArray = <FormArray>group.controls['PVA-S'];
        priceArray.push(this.formBuilder.group({
            priceLimit: [''],
            discount: ['']
        }));
    }

    public removeVolumeTreshold(group: FormGroup, index: number) {
        const volumeArray: FormArray = <FormArray>group.controls['PVA-V'];
        volumeArray.removeAt(index);

        const periods: FormArray = <FormArray>this.simulationInputForm.controls['periods'];
        const periodIndex = periods.controls.indexOf(group);
    }

    public removePriceTrashold(group: FormGroup, index: number) {
        const priceArray: FormArray = <FormArray>group.controls['PVA-S'];
        priceArray.removeAt(index);

        const periods: FormArray = <FormArray>this.simulationInputForm.controls['periods'];
        const periodIndex = periods.controls.indexOf(group);
    }

    public isAgreementType(type: string) {
        return this.agreementType.toString().match(type);
    }

    public isPVAType() {

        const isPVAV = this.agreementType.toString() === 'PVA-V';
        const isPVAS = this.agreementType.toString() === 'PVA-S';

        return (isPVAV || isPVAS);
    }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/simulation-input/simulation-input.component.ts